import { ReactNode } from "react";

import { ArrowUpRight } from "@hl/base-components/lib/assets/icons.generated";
import {
  Anchor,
  Box,
  BoxProps,
  Divider,
  Group,
  Stack,
  Text,
} from "@mantine/core";

const LinkItem = ({
  icon,
  title,
  href,
}: {
  icon: ReactNode;
  title: string;
  href: string;
}) => (
  <Anchor href={href} target="_blank" rel="noreferrer">
    <Group position="apart">
      <Group spacing="xs">
        {icon}
        <Text size="sm">{title}</Text>
      </Group>
      <ArrowUpRight width={16} height={16} />
    </Group>
  </Anchor>
);

export type CollectionLink = {
  icon: ReactNode;
  title: string;
  href: string;
};
const CollectionLinksSection = ({
  links,
  ...rest
}: { links: CollectionLink[] } & BoxProps) => {
  return (
    <Box {...rest}>
      <Stack spacing={14}>
        {links.map((link) => (
          <div key={link.title}>
            <LinkItem icon={link.icon} title={link.title} href={link.href} />
            <Divider mt={14} />
          </div>
        ))}
      </Stack>
    </Box>
  );
};

export default CollectionLinksSection;
